import React from "react";

import Form from "../../../UI/Form/Form";
import Icon from "../../../UI/Icon/Icon";
import Input from "../../../UI/Form/Input/Input";
import Button from "../../../UI/Button/Button";
const search = (props) => {
  const changeHandler = () => {};
  const onClickHandler = () => {};

  return (
    <>
      {/* <div className="collapse navbar-search-overlap" id="site-navbar-search">
        <Form formRole="search">
          <div className="form-group">
            <div className="input-search">
              <Icon iconClass="input-search-icon md-search" />
              <Input
                type="text"
                className="form-control"
                name="site-search"
                placeholder="Search..."
                onChange={changeHandler}
              />
              <Button
                buttonType="button"
                buttonClass="input-search-close icon md-close"
                buttonDataToggle="collapse"
                buttonDataTarget="#site-navbar-search"
                buttonAriaLabel="Close"
              />
            </div>
          </div>
        </Form>
        <Button
          buttonType="button"
          buttonClass="input-search-close icon md-close"
          buttonDataToggle="collapse"
          buttonDataTarget="#site-navbar-search"
          buttonAriaLabel="Close"
        />
      </div> */}
      <Button
        buttonType="button"
        buttonClass="input-search-close icon md-close"
        buttonDataTarget="#site-navbar-search"
        onClick={onClickHandler}
        buttonAriaLabel="Close"
      />
    </>
  );
};

export default search;
